import React from 'react'
import { decamelize } from './utils'
import { JSONDisplayer } from './utils'
function DynamicTable(props) {
  const TableData = props.TableData;

  // get table column
  const column = TableData.length ? (TableData[0] ? Object.keys(TableData[0]): []): [];
  //console.log('column', column)
  // get table heading data
  const ThData = () => {
    return column.map((data) => {
      return (
        <th key={data} style={{ fontSize: '10px', width: 'none', border: "1px solid #000", "background":"#ccc", "position": "inherit" }}>
          <b>{decamelize(data)}</b>
        </th>
      )
    })
  }

  // get table row data
  const tdData = () => {
    return TableData.map((data, index) => {
      return (
        <tr key={`${index}-TR`}>
          {column.map((v) => {
            console.log(data[v]);
            return (
              <td style={{ textAlign: 'center', width: 'fit-content', overflowWrap: "anywhere", padding: '10px', border: "1px solid #000" }}>
                {Array.isArray(data[v]) && typeof data[v][0] === "object" ? (
                  <DynamicTable TableData={data[v]} />
                ) : (
                  data[v] && JSONDisplayer(data[v])
                )}
              </td>
            )
          })}
        </tr>
      )
    })
  }

  return (
    <table className='table' style={{ border: '1px solid', width: '100%' }}>
      <thead>
        <tr>{ThData()}</tr>
      </thead>
      <tbody>{tdData()}</tbody>
    </table>
  )
}
export default DynamicTable
